import { render, staticRenderFns } from "./MailAdresimeErisebiliyorum.vue?vue&type=template&id=85dc6c60&scoped=true"
import script from "./MailAdresimeErisebiliyorum.vue?vue&type=script&lang=js"
export * from "./MailAdresimeErisebiliyorum.vue?vue&type=script&lang=js"
import style0 from "./MailAdresimeErisebiliyorum.vue?vue&type=style&index=0&id=85dc6c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dc6c60",
  null
  
)

export default component.exports